<div  role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title">Holidays</h2>
      </div>
      <div class="modal-body">
        <form #holidayForm="ngForm">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                  <label for="unavailableFrom">Unavailable From</label>
                  <input type="date" class="form-control" name="unavailableFrom" id="unavailableFrom"  placeholder="Unavailable From" [(ngModel)]="holiday.unavailableFrom" required>
              </div>
              <div class="form-group">
                <label for="unavailableTo">Unavailable To</label>
                <input type="date" class="form-control" name="unavailableTo" id="unavailableTo"  placeholder="Unavailable To" [(ngModel)]="holiday.unavailableTo" required>
              </div>
            <div class="form-group">
                <label for="reason">Reason</label>
                <input class="form-control" name="reason" id="reason" placeholder="Reason" [(ngModel)]="holiday.reason">
            </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
          <button type="button" class="btn btn-success" (click)="saveHolidayData(holidayForm.value)" [disabled]="holidayForm.invalid">Save Holiday</button>
          <button type="button" class="btn btn-light" (click)="closeModal()">Close</button>
      </div>
    </div>
  </div>